import type { ApiServiceInterface } from '@travelata-libs/utils';
import { container } from '../di/Container';
import { API_SERVICE_TOKEN } from '../di/tokens';

export function useTravelataApiService(): ApiServiceInterface {
  return container.resolve(API_SERVICE_TOKEN);
}
